import { render, staticRenderFns } from "./CreateShipment.vue?vue&type=template&id=3081d0d0&"
import script from "./CreateShipment.vue?vue&type=script&lang=js&"
export * from "./CreateShipment.vue?vue&type=script&lang=js&"
import style0 from "./CreateShipment.vue?vue&type=style&index=0&id=3081d0d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports